import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { Label, Input, FormGroup, Progress, Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Row, Col, Badge, TabContent, TabPane, Nav, NavItem, NavLink, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import Select from "react-select"
import gql from 'graphql-tag'
import toTitleCase from "../../Functions/toTitleCase"
import StripeTerminal from "../../Stripe/StripeTerminal"
import CarModelGroupIcon from "../../CA/CarModelGroupIcon"
import './RunPickupModal.css'
import { CreateAgreementMutation } from "./Mutations"
import { HasPermissionsQuery } from "../../Functions/querys"
import { ReservationQuery, AllAgreementTypes, AllPaymentMethodsQuery, SubscriptionTypes, StripeCards } from "./Queries"
import StripeCard from "../../Stripe/StripeCard"

import withApolloClient from '../../withApolloClient'

import PickupPaymentPlan from "./PickupPaymentPlan"
const paymentMethods = ["Card Payment", "Terminal Payment"]

const requestCardFromDriver = gql`mutation requestCardFromDriver($input:RequestCardFromDriverMutationInput!){
    requestCardFromDriver(input:$input){
      ok
      errors{
        field
        messages
      }
    }
}`

const VALIDATIONS_TO_SKIP_OPTIONS = [
    { value: "ARGYLE", label: "ARGYLE" },
    { value: "IGNORE_INCOMPLETE_RETURN", label: "IGNORE INCOMPLETE RETURN" }
]

export function MiNavePickupQuestions({ input, updateInput }) {
    return (
        <div>
            <Row>
                <Col>
                    <FormGroup>
                        <Label>Inspection Dates</Label>
                        <Input type="date" className="mb-2" name="inspectionDate1" value={input?.inspectionDate1} min={moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={updateInput} />
                        <Input type="date" className="mb-2" name="inspectionDate2" value={input?.inspectionDate2} min={input?.inspectionDate1 ? input.inspectionDate1 : moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={updateInput} />
                        <Input type="date" className="mb-2" name="inspectionDate3" value={input?.inspectionDate3} min={input?.inspectionDate2 ? input.inspectionDate2 : moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={updateInput} />
                        <Input type="date" className="mb-2" name="inspectionDate4" value={input?.inspectionDate4} min={input?.inspectionDate3 ? input.inspectionDate3 : moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={updateInput} />
                        <Input type="date" className="mb-2" name="inspectionDate5" value={input?.inspectionDate5} min={input?.inspectionDate4 ? input.inspectionDate4 : moment().tz("America/New_York").format(moment.HTML5_FMT.DATE)} onChange={updateInput} />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Label>Driver Accepts to notify us on any changes to thier documents</Label>
                    <div>
                        <span>YES</span>
                        <div className="toggle-switch">
                            <input
                                type="checkbox"
                                className="toggle-switch-checkbox"
                                name="acceptToNotifyOnDocumentChanges"
                                id="acceptToNotifyOnDocumentChanges"
                                checked={!(input && input.acceptToNotifyOnDocumentChanges === true)}
                                onChange={updateInput}
                            />
                            <label className="toggle-switch-label" htmlFor="acceptToNotifyOnDocumentChanges">
                                <span className="toggle-switch-inner" />
                                <span className="toggle-switch-switch" />
                            </label>
                        </div>
                        <span>NO</span>
                    </div>
                </Col>
                <Col>
                    <Label>Driver Accepts Credit Bureau Check</Label>
                    <div>
                        <span>YES</span>
                        <div className="toggle-switch">
                            <input
                                type="checkbox"
                                className="toggle-switch-checkbox"
                                name="acceptCreditBureauCheck"
                                id="acceptCreditBureauCheck"
                                checked={!(input && input.acceptCreditBureauCheck === true)}
                                onChange={updateInput}
                            />
                            <label className="toggle-switch-label" htmlFor="acceptCreditBureauCheck">
                                <span className="toggle-switch-inner" />
                                <span className="toggle-switch-switch" />
                            </label>
                        </div>
                        <span>NO</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Label>Driver Authorizes Receiving Advertising</Label>
                    <div>
                        <span>YES</span>
                        <div className="toggle-switch">
                            <input
                                type="checkbox"
                                className="toggle-switch-checkbox"
                                name="advertisingAuthorized"
                                id="advertisingAuthorized"
                                checked={!(input && input.advertisingAuthorized === true)}
                                onChange={updateInput}
                            />
                            <label className="toggle-switch-label" htmlFor="advertisingAuthorized">
                                <span className="toggle-switch-inner" />
                                <span className="toggle-switch-switch" />
                            </label>
                        </div>
                        <span>NO</span>
                    </div>
                </Col>
                <Col>
                    <Label>Driver Agrees to Review the Policy</Label>
                    <div>
                        <span>YES</span>
                        <div className="toggle-switch">
                            <input
                                type="checkbox"
                                className="toggle-switch-checkbox"
                                name="policyReceived"
                                id="policyReceived"
                                checked={!(input && input.policyReceived === true)}
                                onChange={updateInput}
                            />
                            <label className="toggle-switch-label" htmlFor="policyReceived">
                                <span className="toggle-switch-inner" />
                                <span className="toggle-switch-switch" />
                            </label>
                        </div>
                        <span>NO</span>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

class PickupModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            step: 1,
            paidAmount: 0,
            runPickupError: null,
            runPickupSuccess: false,
            loading: false,
            cardRequestLoading: false,
            cardRequest: false,
            howDriverPayingToday: "Stripe/Card",
            paymentSuccess: false,
            paymentTab: paymentMethods[0],
            subscriptionCreated: false,
            subscriptionTypeId: "",
            paymentMethods: null,
            willGetCdwInsurance: "",
            isDriveSmartEnabled: "",
            validationsToSkip: [],
            input: {
                preferredPaymentMethod: "Card",
                formSubmittedVia: "BOS",
                reservation: this.props.reservationId ? this.props.reservationId : "",
                ignoreMissingCarDocs: false,
                paymentPlan: null,
            }
        }
    }

    runPickup = () => {
        let reservation = this.props.reservation
        if (reservation && reservation.driver && reservation.car && !this.state.loading) {
            try {
                this.setState({ loading: true })
                let input = this.state.input
                if (this.state.isDriveSmartEnabled === "Yes" || this.state.isDriveSmartEnabled === "No") {
                    input["participateInDriveSmart"] = this.state.isDriveSmartEnabled === "Yes"
                }
                if (this.state.willGetCdwInsurance === "Yes" && this.state.subscriptionTypeId) {
                    input["driverSubscription"] = {
                        "paymentMethod": this.state.paymentMethods,
                        "subscriptionTypeId": this.state.subscriptionTypeId
                    }
                }
                if (reservation.agreementType && reservation.agreementType.requireEndDate) {
                    if (input.returnDate) {
                        input["returnDate"] = input.returnDate
                    } else {
                        throw 'Required field missing, Return Date'
                    }
                }
                if (this.state.validationsToSkip && this.state.validationsToSkip.length > 0) {
                    input["validationsToSkip"] = this.state.validationsToSkip
                }
                // Sanitize inspection dates
                for (let i = 1; i <= 5; i++) {
                    if (input["inspectionDate" + i]) {
                        input["inspectionDate" + i] = moment(input["inspectionDate" + i]).format("YYYY-MM-DD")
                    } else {
                        delete input["inspectionDate" + i]
                    }
                }
                this.props.apolloClient.mutate({
                    mutation: CreateAgreementMutation,
                    variables: { input }
                }).then((result) => {
                    if (result && result.data && result.data.createAgreement.ok) {
                        this.setState({ loading: false, runPickupSuccess: true, runPickupError: null })
                    } else {
                        let error_msg = "There was a problem. Please retry."
                        if (result.data && result.data.createAgreement && result.data.createAgreement.errors) {
                            error_msg = result.data.createAgreement.errors[0].messages
                        }
                        this.setState({ loading: false, runPickupError: error_msg })
                    }
                })
            } catch (error) {
                let error_msg = "Error: " + error.toString()
                this.setState({ loading: false, runPickupError: error_msg })
            }
        }
    };

    handleClose = () => {
        let newState = {
            openModal: "",
            runPickupError: null,
            runPickupSuccess: false,
            loading: false,
            howDriverPayingToday: "Stripe/Card",
            paymentSuccess: false,
        }
        this.setState({ ...newState })
        if (this.state.runPickupSuccess && this.props.refetchQuery)
            this.props.refetchQuery()
        this.props.handleClose()
    }

    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (e.target.type === "number") {
            if (isNaN(parseFloat(value))) {
                value = 0
            } else {
                value = parseFloat(value)
            }
        }
        if (e.target.type === "checkbox") {
            value = this.state.input[name] ? !this.state.input[name] : true
        }
        let input = this.state.input
        input[name] = value
        this.setState({ input: input })
    };

    paymentSuccess = (amount) => {
        this.props.refetchReservationQuery()
        this.setState({ paymentSuccess: true, paidAmount: this.state.paidAmount + amount })
    }

    handleBackEvent = () => {
        this.props.refetchReservationQuery()
        this.setState({ step: 1 })
    }

    requestCardFromDriver = () => {
        this.setState({ cardRequestLoading: true })
        let input = {
            driverId: this.props.driverId
        }
        this.props.apolloClient.mutate({
            mutation: requestCardFromDriver,
            variables: { input }
        }).then((result) => {
            if (result && result.data && result.data.requestCardFromDriver && result.data.requestCardFromDriver.ok) {
                this.setState({ cardRequestLoading: false, cardRequest: true })
            } else {
                let errorMessage = "Request New Card Failed"
                if (result.data.requestCardFromDriver.errors && result.data.requestCardFromDriver.errors[0] && result.data.requestCardFromDriver.errors[0].messages) {
                    errorMessage = result.data.requestCardFromDriver.errors[0].messages
                }
                this.setState({ error: errorMessage, cardRequestLoading: false, cardRequest: false })
            }
        })
    }

    componentDidMount() {
        const { apolloClient } = this.props
        this.handleMinaveValidation()
    }

    componentDidUpdate(prevProps) {
        const { reservation } = this.props
        if (reservation?.id !== prevProps.reservation?.id && !this.state.validationsToSkip?.length) {
            this.handleMinaveValidation()
        }
    }

    handleMinaveValidation = () => {
        const { reservation } = this.props
        const branch = reservation?.driver?.branch
        const isMinave = branch?.tenant?.customId?.toLowerCase() === "mnave" || (branch?.name && branch.name.toLowerCase().includes("mi nave"))
        if (isMinave) {
            this.setState({ validationsToSkip: ["ARGYLE"] })
        }
    }

    render() {
        let reservation = this.props.reservation
        if (!reservation && this.props.reservationLoading) {
            return (
                <Modal isOpen={this.props.open} className="pickup-modal" style={{ minWidth: "850px" }}>
                    <ModalHeader className="title">Run Pickup</ModalHeader>
                    {/* Show loading component  */}
                    <ModalBody>
                        <Row>
                            <Col xs={12}>
                                <Progress animated color="info" value="100" />
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            )
        }
        const filteredPreferredBases = ["Uber", "Lyft", "Via", "Didi", "Cabify", "Multi-platform", "Other"]
        let branch = reservation && reservation.branch ? reservation.branch : null
        const isMinave = branch && branch.name && branch.name.toLowerCase().includes("mi nave")

        const { agreementType, reservationpromoSet } = reservation
        const chargeType = agreementType?.chargeType
        const promoEdges = reservationpromoSet?.edges ?? []

        const promoNode = promoEdges[0]?.node
        const promoPrice = promoNode?.promoPrice ?? 0
        const promoStartDateInTheFuture = promoNode?.startDate && moment(promoNode.startDate).isAfter(moment())

        const hasPrePay = chargeType === "PRE_PAY"
        const hasPromo = promoPrice > 0
        const hasPromoApplied = hasPrePay && hasPromo && !promoStartDateInTheFuture

        if ((!this.state.runPickupError || this.state.runPickupError === "") && reservation && reservation.car && reservation.car.unresolvedCarIssues && reservation.car.unresolvedCarIssues.length > 0 && reservation.car.unresolvedCarIssues.filter(issue => !issue.canPickup || issue.canPickup === false).length > 0) {
            this.setState({ runPickupError: "Unable to run the pickup. Open issues found including " + (reservation.car.unresolvedCarIssues.filter(issue => !issue.canPickup || issue.canPickup === false).map(({ issueCategory }) => issueCategory.category).join(", ")) + ". Please resolve these issues." })
        }
        let requiredDepositToday = reservation && reservation.driver ? (reservation.driver.deposit ? Math.max(reservation.depositAmount - reservation.driver.deposit, 0) : reservation.depositAmount) : 0
        let firstRentalCharge = reservation && reservation.reservationPrice && reservation.reservationPrice.edges && reservation.reservationPrice.edges.length > 0 ? reservation.reservationPrice.edges[0].node.price : 0

        // Apply promo discount for PRE_PAY, ensuring result isn't negative in case promo exceeds rental price.
        let prepaidRentalCharge = hasPrePay
            ? parseFloat(hasPromoApplied
                ? Math.max(firstRentalCharge - promoPrice, 0)
                : firstRentalCharge)
            : 0

        let driverBalance = parseFloat((reservation && reservation.driver ? reservation.driver.balance - this.state.paidAmount : 0).toFixed(2))
        let baseCharge = reservation?.driver?.paymentplanSet?.edges?.length > 0
            ? reservation.driver.currentCharge
            : driverBalance
        let badDebt = reservation?.driver?.balanceWriteOff < 0 ? (reservation.driver.balanceWriteOff * -1) : 0
        let surcharge = hasPrePay ? (reservation.surcharge || 0) : 0

        let amountToPay = Math.max(baseCharge + requiredDepositToday + prepaidRentalCharge + badDebt + surcharge, 0).toFixed(2)

        let ppAmount = this.state.input.paymentPlan && this.state.input.paymentPlan.inputTransactions ? this.state.input.paymentPlan.inputTransactions.filter(txn => txn.amount).reduce((sum, transaction) => sum + transaction.amount, 0) : 0

        amountToPay -= ppAmount

        let isSwitch = reservation && reservation.pickupType && reservation.pickupType.toLowerCase().includes("switch")

        const activeSubscriptionTypeExists = reservation && reservation.agreementType && reservation.agreementType.subtypeSet && reservation.agreementType.subtypeSet.edges && reservation.agreementType.subtypeSet.edges.length >= 1
        const enableSmartWorkFlow = reservation && reservation.branch && reservation.branch.branchSettings && reservation.branch.branchSettings.edges && reservation.branch.branchSettings.edges.some(edge => edge.node && edge.node.key && edge.node.key.name === 'ENABLE_DRIVESMART')
        const carIsEligibleForDriveSmart = reservation?.car?.equipmentSet?.edges?.some(edge => {
            const { telemetryStatus, equipmentItems } = edge.node
            return equipmentItems?.customId === "general-motors-onstar" && (!telemetryStatus || telemetryStatus?.toString()?.toUpperCase() === "PRESENT")
        })

        return (
            <Modal isOpen={this.props.open} className="pickup-modal" style={{ minWidth: "850px" }}>
                <ModalHeader className="title">Run Pickup</ModalHeader>
                {reservation && !this.state.loading &&
                    <ModalBody>
                        <Row>
                            {(this.state.loading || this.props.loading || this.props.reservationLoading) && <Col xs={12}> <Progress animated color="info" value="100" /> </Col>}
                            {this.state.runPickupError && !this.state.runPickupSuccess && <Col xs={12}><Alert color="danger">{this.state.runPickupError}</Alert></Col>}
                            {!this.state.runPickupError && this.state.runPickupSuccess && <Col xs={12}><Alert color="success">{`Pick up is now compete. Please have the Driver review and sign the agreement that was sent to ${reservation.driver.email}. Thank you`} </Alert></Col>}
                        </Row>
                        <Row>
                            <Col className="align-self-center">
                                <Label>Driver Info</Label>
                                <FormGroup>
                                    <div>
                                        <span>
                                            <small>{reservation && reservation.driver.tlcLicense}&nbsp;&nbsp;
                                                <a href={"/driver/" + reservation.driver.id} target="_blank">
                                                    <i className="fa fa-external-link color-blue"></i>
                                                </a>
                                            </small>
                                        </span>
                                        <br />
                                        <span className="reservation-driver-name">{reservation && reservation.driver.name}</span>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col className="align-self-center">
                                <Label>Car Info</Label>
                                <FormGroup className="d-flex flex-row">
                                    <div className="align-self-center pr-2">
                                        <CarModelGroupIcon carGroup={reservation && reservation.car.carModel.groupType ? reservation.car.carModel.groupType.name : null} carColor={reservation && reservation.car.color} id={reservation && reservation.car.pk} />
                                        <br />
                                        <span>
                                            {reservation.car.pk}
                                        </span>
                                    </div>
                                    <div className="car-name-years align-self-center">
                                        <small>
                                            {reservation.car?.year || ""} | {reservation.car?.color || ""} {reservation.car.carModel.groupType ? "| " + reservation.car.carModel.groupType.name : ""} | {reservation.car?.dmvPlate || ""} &nbsp;&nbsp;
                                            <a href={"/car/" + reservation.car.pk} target="_blank">
                                                <i className="fa fa-external-link color-blue"></i>
                                            </a>
                                        </small>
                                        <div className="car-name">
                                            {toTitleCase(reservation.car.carModel.make)} {toTitleCase(reservation.car.carModel.name)} <small>{reservation.car.carModel.series ? `(${reservation.car.carModel.series})` : ''}</small>
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Agreement Type</Label>
                                    <br />
                                    <p>{reservation && reservation.agreementType.name}</p>
                                </FormGroup>
                            </Col>
                            <Col>
                                {reservation && reservation.agreementType &&
                                    <FormGroup>
                                        <Label>Return Date</Label>
                                        <Input type="datetime-local" value={this.state.input.returnDate} name="returnDate" min={moment().tz("America/New_York").format(moment.HTML5_FMT.DATETIME_LOCAL)} onChange={this.updateInput} required={reservation.agreementType.requireEndDate} />
                                    </FormGroup>
                                }
                            </Col>

                            {isMinave &&
                                <Col>
                                    <FormGroup>
                                        <Label>First Payment Amount</Label>
                                        <br />
                                        <p>${reservation && reservation.firstPayment ? reservation.firstPayment : '0'}</p>
                                    </FormGroup>
                                </Col>
                            }

                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Pickup Type</Label>
                                    <br />
                                    <p>{reservation && toTitleCase(reservation.pickupType)}</p>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label for="preferredBase">Company Driver Will Drive For?</Label>
                                    {isMinave ? (
                                        <Select
                                            className="bos-custom-select"
                                            classNamePrefix="bos-select"
                                            options={filteredPreferredBases.map(base => ({ label: base, value: base }))}
                                            placeholder="What Company will the driver drive for?"
                                            isMulti
                                            value={(this.state.input.preferredBase || []).map(value => ({ label: value, value }))}
                                            onChange={(option) => {
                                                const preferredBases = option ? option.map(o => o.value) : []
                                                this.setState({
                                                    input: { ...this.state.input, preferredBase: preferredBases },
                                                    customPreferredBase: preferredBases.includes("Other") ? "" : null
                                                })
                                            }}
                                        />
                                    ) : (
                                        <Select
                                            className="bos-custom-select"
                                            classNamePrefix="bos-select"
                                            options={filteredPreferredBases.map(base => ({ label: base, value: base }))}
                                            placeholder="What Company will the driver drive for?"
                                            onChange={(option) => {
                                                this.setState({
                                                    input: { ...this.state.input, preferredBase: option.value },
                                                    customPreferredBase: option.value === "Other" ? "" : null
                                                })
                                            }}
                                        />
                                    )}
                                </FormGroup>
                                {/* Show field to specify another company if user selects "Other" */}
                                {this.state.input.preferredBase === "Other" && (
                                    <FormGroup>
                                        <Label for="customPreferredBase">Specify Other Company</Label>
                                        <Input
                                            type="text"
                                            id="customPreferredBase"
                                            placeholder="Enter company name"
                                            value={this.state.customPreferredBase || ""}
                                            onChange={(e) => this.setState({ customPreferredBase: e.target.value })}
                                        />
                                    </FormGroup>
                                )}
                            </Col>
                        </Row>
                        {isMinave && <MiNavePickupQuestions input={this.state.input} updateInput={this.updateInput} />}
                        {this.props.hasPermissions && (this.props.hasPermissions.includes("custom_can_skip_validations") || this.props.hasPermissions.includes("custom_can_skip_incomplete_return_validation")) &&
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Validations to skip</Label>
                                        <br />
                                        <Select className="bos-custom-select"
                                            classNamePrefix="bos-select" isLoading={false}
                                            options={
                                                VALIDATIONS_TO_SKIP_OPTIONS.filter(validation =>
                                                    validation.value !== "IGNORE_INCOMPLETE_RETURN" ||
                                                    this.props.hasPermissions?.includes("custom_can_skip_incomplete_return_validation")
                                                ).map(validation => ({
                                                    value: validation.value,
                                                    label: validation.label
                                                }))
                                            }
                                            placeholder="Select validations to skip"
                                            isMulti
                                            value={this.state.validationsToSkip?.map(val => ({ value: val, label: val })) || null}
                                            onChange={(option) => this.setState({ validationsToSkip: option.map(item => item.value) })}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                        {enableSmartWorkFlow && carIsEligibleForDriveSmart &&
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <Label>Would the driver like to participate in the Drive Smart Program? *</Label>
                                        <Select
                                            className="bos-custom-select"
                                            classNamePrefix="bos-select"
                                            value={this.state.isDriveSmartEnabled === "Yes" ? { label: "YES", value: "Yes" } : this.state.isDriveSmartEnabled === "No" ? { label: "NO", value: "No" } : null}
                                            options={[{ label: "YES", value: "Yes" }, { label: "NO", value: "No" },]}
                                            placeholder="Must Choose One"
                                            onChange={(option) => this.setState({ isDriveSmartEnabled: option.value })}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                        {this.state.step === 1 && activeSubscriptionTypeExists &&
                            <>
                                <hr />
                                <Row>
                                    <Col xs={12}>
                                        <FormGroup>
                                            <Label for="willGetCdwInsurance?">Is driver signing up for CDW Deductible Insurance?</Label>
                                            <Select
                                                isDisabled={reservation.driver && reservation.driver?.subSet && reservation.driver?.subSet.edges && reservation.driver?.subSet.edges.length > 0}
                                                className="bos-custom-select"
                                                classNamePrefix="bos-select"
                                                defaultValue={(reservation.driver && reservation.driver?.subSet && reservation.driver?.subSet.edges && reservation.driver?.subSet.edges.length > 0) ? [{ label: "YES", value: "Yes" }] : this.state.willGetCdwInsurance === "Yes" ? [{ label: "YES", value: "Yes" }] : this.state.willGetCdwInsurance === "No" ? [{ label: "NO", value: "No" }] : null}
                                                options={[{ label: "YES", value: "Yes" }, { label: "NO", value: "No" }]}
                                                placeholder="Please Choose One"
                                                onChange={(option) => this.setState({ willGetCdwInsurance: option.value })}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {this.state.willGetCdwInsurance === "Yes" && reservation.driver && reservation.driver.id &&
                                    <Row>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label for="subscriptionTypeId">Which subscription is the driver signing up for?</Label>
                                                <Select
                                                    className="bos-custom-select"
                                                    classNamePrefix="bos-select"
                                                    options={this.props.allSubscriptionTypes && this.props.allSubscriptionTypes.edges && this.props.allSubscriptionTypes.edges.length > 0 && this.props.allSubscriptionTypes.edges.map(item => ({ value: item.node.id, label: item.node.name + " - Deductible: $" + item.node.deductibleAmount + " - Payment: $" + item.node.amount }))}
                                                    placeholder="Please Choose One"
                                                    onChange={(option) => this.setState({ subscriptionTypeId: option.value })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12}>
                                            <FormGroup>
                                                <Label for="paymentMethods">How will driver pay for this subscription?</Label>
                                                <Select
                                                    className="bos-custom-select"
                                                    classNamePrefix="bos-select"
                                                    defaultValue={[{ value: null, label: "Use Default Card" }]}
                                                    options={this.props.cards && this.props.cards.cards && this.props.cards.cards.length > 0 ? [{ value: null, label: "Use Default Card" }, ...this.props.cards.cards.map(card => ({ value: card.id, label: (card.brand + ": **" + card.last4 + ". Exp: " + card.expMonth + "/" + card.expYear) }))] : [{ value: null, label: "Use Default Card" }]}
                                                    onChange={(card) => this.setState({ paymentMethods: card.value })}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} className="d-flex justify-content-end">
                                            {this.state.cardRequestLoading ?
                                                <span>{this.state.cardRequestLoading ? "Loading...please wait..." : this.state.cardRequestLoading}</span> :
                                                <Button className="cdw-signup-modal-primary-btn" disabled={this.state.cardRequest} onClick={this.requestCardFromDriver}>{this.state.cardRequest ? "Link Triggred" : "Request Card"}</Button>
                                            }
                                        </Col>
                                    </Row>
                                }
                                <br />
                            </>
                        }
                        {reservation.driver && reservation.driver?.subSet && reservation.driver?.subSet.edges && reservation.driver?.subSet.edges.length > 0 &&
                            <Row>
                                <Col xs={6}>
                                    <Label>Subscription Detail</Label>
                                    <p className="columnContent">{reservation.driver?.subSet.edges[0].node.subType ? reservation.driver?.subSet.edges[0].node.subType.name + " - Deductible: $" + reservation.driver?.subSet.edges[0].node.subType.deductibleAmount + " - Amount: $" + reservation.driver?.subSet.edges[0].node.subType.amount : "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Status</Label>
                                    <p className="columnContent">{reservation.driver?.subSet.edges[0].node.statusDisplay ? reservation.driver?.subSet.edges[0].node.statusDisplay : "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Created By</Label>
                                    <p className="columnContent">{reservation.driver?.subSet.edges[0].node.createdBy ? reservation.driver.subSet.edges[0].node.createdBy.firstName ? reservation.driver.subSet.edges[0].node.createdBy.firstName + " " + reservation.driver?.subSet.edges[0].node.createdBy.lastName : reservation.driver.subSet.edges[0].node.createdBy.username : "--"}</p>
                                </Col>
                            </Row>
                        }
                        {(this.state.step === 2 || !activeSubscriptionTypeExists) && <>
                            <hr />
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label>Driver Balance</Label>
                                        <br />
                                        <p className={(driverBalance + badDebt) > 0 ? "text-danger" : "text-success"}>${reservation.driver.currentCharge !== driverBalance ?
                                            <>
                                                <UncontrolledTooltip target="currentCharge">Current Charge</UncontrolledTooltip>
                                                {driverBalance + badDebt}&nbsp;
                                                <i className="fa fa-long-arrow-right"></i>&nbsp;
                                                <span id="currentCharge">{reservation.driver.currentCharge + badDebt}</span>
                                            </> :
                                            driverBalance + badDebt}</p>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label>Required Deposit</Label>
                                        <br />
                                        <p>
                                            <UncontrolledTooltip target={"currentDeposit"}>Driver Current Deposit</UncontrolledTooltip>
                                            <UncontrolledTooltip target={"reservationDeposit"}>Reservation Deposit</UncontrolledTooltip>
                                            <UncontrolledTooltip target={"requiredDeposit"}>Required Deposit Today</UncontrolledTooltip>
                                            <small id="reservationDeposit">${reservation.depositAmount || 0}</small> - <small id="currentDeposit">${reservation.driver && reservation.driver.deposit ? reservation.driver.deposit : "0"}</small> = <span id="requiredDeposit" className={requiredDepositToday <= 0 ? "text-success" : "text-danger"}>${requiredDepositToday}</span>
                                        </p>
                                    </FormGroup>
                                </Col>
                                {prepaidRentalCharge > 0 && <Col>
                                    <FormGroup>
                                        <Label>Pickup Payment&nbsp;
                                            <span id="pickupPaymentInfo" style={{ display: 'inline-block' }}>
                                                <i
                                                    className="fa fa-info-circle"
                                                    aria-hidden="true"
                                                />
                                            </span>
                                        </Label>
                                        <br />
                                        <p>
                                            <small id="deposit">{requiredDepositToday}</small> +
                                            <small id="firstRentalCharge"> {parseFloat(firstRentalCharge)}</small>
                                            {surcharge > 0 && <>
                                                + <small id="surcharge"> {parseFloat(surcharge)}</small>
                                                <UncontrolledTooltip target="surcharge">Insurance Surcharge.</UncontrolledTooltip>
                                            </>}
                                            {hasPromoApplied && <small id="promoPrice" className={"text-success"} > - {parseFloat(promoPrice)}</small>} =
                                            <span id="pickupPayment"> ${requiredDepositToday + prepaidRentalCharge + surcharge} </span>
                                            {hasPromoApplied && <span id="promoTagIcon" style={{ display: "inline-block" }}>
                                                <i className="fa fa-tag text-success" style={{ fontSize: '0.7em' }} aria-hidden="true"></i>
                                            </span>}
                                            <UncontrolledTooltip target="deposit">Required deposit today.</UncontrolledTooltip>
                                            <UncontrolledTooltip target="firstRentalCharge">First rental charge.</UncontrolledTooltip>
                                            <UncontrolledTooltip target="pickupPayment">Pickup payment.</UncontrolledTooltip>
                                            {hasPromoApplied && <>
                                                <UncontrolledTooltip target="promoTagIcon">${promoPrice} promo discount applied.</UncontrolledTooltip>
                                                <UncontrolledTooltip target="promoPrice">Promo discount.</UncontrolledTooltip>
                                            </>}
                                            <UncontrolledTooltip target="pickupPaymentInfo">
                                                (Deposit + Initial Rent  {hasPrePay && <>+ Insurance Surcharge</>}) - Any Promo = Required Payment
                                            </UncontrolledTooltip>
                                        </p>
                                    </FormGroup>
                                </Col>}
                                <Col>
                                    <FormGroup>
                                        <Label>Amount To Be Paid</Label>
                                        <br />
                                        <p id={"remainingBalance"} className={!isSwitch && amountToPay > 0 ? "text-danger" : "text-success"}>
                                            ${!isSwitch && amountToPay !== 0 ? amountToPay.toFixed(2) : 0}
                                            {(reservation && reservation.driver && reservation.driver.branch && reservation.driver.branch.tenant && reservation.driver.branch.tenant.customId !== "mnave") && !reservation.driver.hasActivePlan && this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_add_plan_on_pickup") && (amountToPay > 0 || this.state.input.paymentPlan) && <>
                                                <i id="paymentPlan" className="fa fa-lg fa-credit-card float-right" style={ppAmount > 0 ? { color: "#28a745" } : { color: "#0066cc" }} aria-hidden="true" onClick={() => this.setState({ openModal: "addPP" })}></i>
                                                <UncontrolledTooltip target="paymentPlan">{this.state.input.paymentPlan ? "Edit" : "Add"} Payment Plan</UncontrolledTooltip>
                                                <PickupPaymentPlan open={this.state.openModal === "addPP"} driverId={reservation.driver.id} expectedBillingDay={reservation.expectedBillingDay} depositAmount={requiredDepositToday} rentalAmount={prepaidRentalCharge} amountToPay={amountToPay + ppAmount} ppInfo={this.state.input.paymentPlan} handleClose={() => this.setState({ openModal: "" })} handleSave={(data) => this.setState({ input: { ...this.state.input, paymentPlan: data } })} />
                                            </>}
                                        </p>
                                    </FormGroup>
                                </Col>
                            </Row>
                            {isSwitch && amountToPay > 0 && !reservation?.driver?.hasActivePlan && <Row>
                                <Col xs={12}>
                                    <Alert color="warning">
                                        <strong>Note:</strong> ⚠️ This driver has an outstanding balance. Please consider setting up a payment plan.
                                    </Alert>
                                </Col>
                            </Row>}
                            {!isSwitch && amountToPay > 0 && reservation && reservation.driver && reservation.driver.branch && reservation.driver.branch.tenant && reservation.driver.branch.tenant.customId !== "mnave" &&
                                // Payment row
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="howDriverPayingToday">How Is The Driver Paying Today?</Label>
                                            <Select
                                                className="bos-custom-select"
                                                classNamePrefix="bos-select"
                                                options={["Stripe/Card", "Cash"].filter(item => (reservation && reservation.branch && reservation.branch.customId === "BROOKLYN_NY") ? true : item === "Stripe/Card").map((item) => ({ label: item, value: item }))}
                                                placeholder="How is the driver"
                                                defaultValue={{ value: "Stripe/Card", label: "Stripe/Card" }}
                                                isDisabled={true}
                                                onChange={(option) => this.setState({ howDriverPayingToday: option.value })}
                                            />
                                        </FormGroup>
                                    </Col>
                                    {(this.state.howDriverPayingToday.includes('Stripe/Card') &&
                                        <>
                                            <Col xs={12}>
                                                <Nav tabs>
                                                    {paymentMethods.map((paymentMethod) => (
                                                        <NavItem className={this.state.paymentTab === paymentMethod ? "active" : "inactive"} style={{ "cursor": "pointer" }}>
                                                            <NavLink className={`${this.state.paymentTab === paymentMethod ? 'active' : ''}`} onClick={() => { this.setState({ paymentTab: paymentMethod }) }}>{paymentMethod} </NavLink>
                                                        </NavItem>
                                                    ))}
                                                </Nav>
                                                <br />
                                                <TabContent activeTab={this.state.paymentTab}>
                                                    <TabPane tabId={paymentMethods[0]}><Row><Col sm="12">
                                                        <StripeCard
                                                            driverId={reservation.driver ? reservation.driver.id : null}
                                                            actions={["pay", "requestCard", "cardOnFile"]}
                                                            isPickupPayment={true}
                                                            paymentSuccess={(amount) => this.paymentSuccess(amount)}
                                                            amountToPay={amountToPay}
                                                        />
                                                    </Col></Row></TabPane>
                                                    <TabPane tabId={paymentMethods[1]}><Row><Col sm="12">
                                                        <StripeTerminal
                                                            driverId={reservation.driver ? reservation.driver.id : null}
                                                            paymentSuccess={(amount) => this.paymentSuccess(amount)}
                                                            description="Payment for pickup" />
                                                    </Col></Row></TabPane>
                                                </TabContent>
                                            </Col>
                                        </>)
                                    }
                                </Row>
                            }
                        </>}
                    </ModalBody>
                }
                {this.state.loading || this.props.loading || this.props.reservationLoading ?
                    <Progress animated color="info" value="100" /> :
                    <ModalFooter>
                        {this.state.step === 2 && activeSubscriptionTypeExists && <Col className="d-flex justify-content-start">
                            <Button className="pickup-model-secondary-btn" onClick={this.handleBackEvent}>Back</Button>
                            {this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_ignore_missing_car_docs") &&
                                <span>
                                    <Label className="pt-2 pl-2" for="ignoreMissingCarDocs" >ignore missing car docs</Label>
                                    <Input
                                        type="checkbox"
                                        id="ignoreMissingCarDocs"
                                        checked={this.state.input.ignoreMissingCarDocs}
                                        onChange={() => this.setState({ input: { ...this.state.input, ["ignoreMissingCarDocs"]: !this.state.input.ignoreMissingCarDocs } })}
                                        style={{ transform: 'scale(1.2)', marginLeft: "7px", marginTop: "10px" }}
                                    />
                                </span>
                            }
                        </Col>}
                        <Col className="d-flex justify-content-end">
                            <Button className="pickup-model-secondary-btn" onClick={this.handleClose}>Close</Button>&nbsp;&nbsp;
                            {(this.state.step === 2 || !activeSubscriptionTypeExists) ?
                                <Button
                                    className="pickup-model-primary-btn"
                                    disabled={
                                        this.state.loading
                                        || this.state.runPickupSuccess
                                        || (this.state.howDriverPayingToday
                                            && this.state.howDriverPayingToday.includes('Stripe/Card')
                                            && !isSwitch
                                            && amountToPay > 0
                                        )
                                        || (isMinave
                                            && (!this.state.input.acceptToNotifyOnDocumentChanges
                                                || !this.state.input.acceptToNotifyOnDocumentChanges
                                                || !this.state.input.acceptCreditBureauCheck
                                                || !this.state.input.policyReceived
                                            )
                                        )
                                        || (enableSmartWorkFlow && carIsEligibleForDriveSmart && this.state.isDriveSmartEnabled === "")
                                    }
                                    onClick={this.runPickup}
                                >
                                    Run Pickup
                                </Button>
                                : ""
                            }
                            {activeSubscriptionTypeExists && this.state.step === 1 &&
                                <Button className="pickup-model-primary-btn"
                                    disabled={reservation.driver && reservation.driver?.subSet && reservation.driver?.subSet.edges && reservation.driver?.subSet.edges.length > 0 ? false : (this.state.willGetCdwInsurance !== "No" && (!this.state.subscriptionTypeId))} onClick={() => this.setState({ step: 2 })}>Next</Button>}
                        </Col>
                    </ModalFooter>
                }
            </Modal>
        )
    }
}


//-----------------------------------
export default graphql(AllPaymentMethodsQuery, {
    options: { fetchPolicy: 'cache-first' },
    props: ({ data: { loading, allPaymentMethods } }) => ({
        loading,
        allPaymentMethods,
    }),
})(
    graphql(AllAgreementTypes, {
        props: ({ data: { allAgreementTypes } }) => ({
            allAgreementTypes,
        }),
    })(
        graphql(ReservationQuery, {
            options: ({ reservationId }) => ({
                variables: { id: reservationId },
                fetchPolicy: 'cache-and-network',
            }),
            props: ({ data: { loading: reservationLoading, reservation, refetch, variables } }) => ({
                reservation,
                reservationLoading,
                variables,
                refetchReservationQuery: () => {
                    return refetch({
                        query: ReservationQuery,
                        variables: { ...variables },
                        updateQuery: (previousResult, { fetchMoreResult }) => ({
                            loading: reservationLoading,
                            reservation: fetchMoreResult.reservation,
                        }),
                    })
                },
            }),
        })(
            graphql(SubscriptionTypes, {
                options: ({ agreementTypeId }) => ({
                    fetchPolicy: 'cache-and-network',
                    variables: { agreementTypeId },
                }),
                props: ({ data: { loading, allSubscriptionTypes } }) => ({
                    loading,
                    allSubscriptionTypes,
                }),
            })(
                graphql(StripeCards, {
                    options: ({ driverId }) => ({
                        fetchPolicy: 'cache-and-network',
                        variables: { id: driverId },
                    }),
                    props: ({ data: { loading, cards, variables } }) => ({
                        loading,
                        cards,
                        variables,
                    }),
                })(
                    graphql(HasPermissionsQuery, {
                        options: () => ({
                            variables: {
                                userPermissions: [
                                    'custom_can_ignore_missing_car_docs',
                                    'custom_can_skip_validations',
                                    "custom_can_add_plan_on_pickup",
                                    "custom_can_skip_incomplete_return_validation"
                                ],
                            },
                        }),
                        props: ({ data: { hasPermissions, loading, variables } }) => ({
                            hasPermissions,
                            loading,
                            variables,
                        }),
                    })(
                        withApolloClient(PickupModal)
                    )
                )
            )
        )
    )
)
